import React, { useRef, ReactNode } from 'react';
import './widget.scss';

/**
 * Widget Component for each entity on the home page
 * @param props
 * @constructor
 */
export const Widget = ({
  // heading of the widget
  heading,
  // Adding all the children/widget items to be shown
  children,
  entityName,
  hasError,
  componentName,
}: {
  heading: string;
  children?: ReactNode;
  entityName: string;
  hasError: boolean;
  componentName: string;
}) => {
  const widgetContentRef = useRef<HTMLDivElement | null>(null);
  const getChildrenList = (children: ReactNode) => {
    return React.Children.toArray(children);
  };
  const renderChildren = (children?: React.ReactNode) => {
    if (!children || React.Children.count(children) === 0) {
      return null;
    }
    return React.Children.map(getChildrenList(children), (child, index) => (
      <div className="widget-item" key={index}>
        {child}
      </div>
    ));
  };

  return (
    <div className="home-widget flex-column justify-space-between">
      <div className="flex justify-space-between">
        <h3 className="widget-heading">{heading}</h3>
      </div>
      <div className="widget-content" ref={widgetContentRef}>
        {hasError ? (
          <div className="widget-error">
            Unable to fetch {componentName} {entityName} at the moment
          </div>
        ) : (
          renderChildren(children)
        )}
      </div>
      <div className="widget-footer"></div>
    </div>
  );
};
